<div class="sidebar included">
	<app-sidebar-header [title]="'ancillaries.group.KIOSK' | ibeadmin: 'sync'"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
	
		<app-flight-route [flight]="flight" *ngIf="flight"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<app-included-per-passenger [flight]="flight" [brand]="brand" [feature]="feature" [passengers]="passengerList" *ngIf="flight">
		</app-included-per-passenger>
		
		<div class="sidebar-flight-text">
			<h2 class="title-h2">
				{{ 'whatsIncludedSidebars.detailsKiosk.titles.digitalKiosk' | ibeadmin: 'sync' }}
			</h2>
			<p class="muted">
				{{ 'whatsIncludedSidebars.detailsKiosk.texts.downloadUpTo1' | ibeadmin: 'sync' }} {{ kiosk_count }} {{ 'whatsIncludedSidebars.detailsKiosk.texts.downloadUpTo2' | ibeadmin: 'sync' }}
			</p> 
			<a (click)="INDRA_gotoURL('externalURLs.aboutDigitalKiosk')" 
				href="javascript:;"
				class="link extras-feature__link link--external" 
				aria-label="All about Digital Kiosk, opens new window">
				 {{ 'whatsIncludedSidebars.detailsKiosk.texts.allAboutKiosk' | ibeadmin: 'sync' }}
			</a>
			<div class="grid no-padding" *ngIf="isMYB">
				<div class="col-5 col-tp-6 col-p-12">
					<button (click)="INDRA_redirectToUrl('externalURLs.downloadIOS')"
							class="button " 
							aria-label="Download up to 2 magazines or newspapers on IOS.">
							{{ 'whatsIncludedSidebars.detailsKiosk.button.iosDownload' | ibeadmin: 'sync' }}
					</button>
				</div>
				<div class="col-5 col-tp-6 col-p-12">
					<button (click)="INDRA_redirectToUrl('externalURLs.downloadAndroid')"
							class="button " 
							aria-label="Download up to 2 magazines or newspapers on Android.">
							{{ 'whatsIncludedSidebars.detailsKiosk.button.androidDownload' | ibeadmin: 'sync' }}
					</button>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" 
					aria-label="Close dialog" 
					(click)="INDRA_handleClose()" 
					href="javascript:;"
					role="button">
					{{ 'whatsIncludedSidebars.general.text.closeWindow' | ibeadmin: 'sync' }}
				</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
e
